<app-navbar>
    <h2>Content Page</h2>
</app-navbar>


<section class="privacy-area pt-100">
    <div class="container">
        Whatever content
    </div>
</section>
<app-footer></app-footer>
